<template>
  <v-app>
  <router-view></router-view>
  </v-app>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";

@import "styles";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
.container {
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 1264px) {
  .container {
    max-width: 100% !important
  }
}
@media (min-width: 1680px) {
  .container {
    max-width: 90% !important
  }
}
@media (min-width: 1904px) {
  .container {
    max-width: 80% !important;
  }
}
.container--fluid {
  max-width: 100%;
}
.theme--light.v-application {
  background: transparent !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>

<script>
import {OVERRIDE_LAYOUT_CONFIG} from "@/core/services/store/config.module";
import {UPDATE_COMPANY, UPDATE_SELECTED_CERTFICATE, UPDATE_SELECTED_SLOT} from "@/core/services/store/profile.module";

export default {
  name: "MetronicVue",
  mounted() {
    const Selected_certficate = JSON.parse(localStorage.getItem('selected_certficate'))
    const Selected_slot = JSON.parse(localStorage.getItem('selected_slot'))
    const Company = JSON.parse(localStorage.getItem('company'))

    this.$store.dispatch(UPDATE_SELECTED_CERTFICATE,Selected_certficate);
    this.$store.dispatch(UPDATE_SELECTED_SLOT,Selected_slot);
    this.$store.dispatch(UPDATE_COMPANY,Company);
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  }
};
</script>
